



<template>
  <div class>

    <div
      style="background:url('../../../static/search/roomTopBg.png') ;background-repeat: repeat-x; max-width:480px; height:0.7rem ; width:100% ; position:absolute ;  z-index:11; "
    ></div>

    <img
      src="../../../static/home/Brand/GoBack.png"
      v-on:click="goback()"
      style="margin:0.4rem 0.1rem 0.1rem 0.45rem ;height:0.45rem;  position:fixed ; z-index:12;"
    >

    <!-- <div style=" position:absolute "> </div>   这个不知道干嘛的-->
    <swiper :options="swiperOption" style=" text-align:center" id="BrandIntroduce" v-if="IsShow">
      <div class="swiper-pagination" slot="pagination"></div>
      <swiper-slide v-for="(item,index) in PicBig" :key="index">
        <img :src="item" style="width:100%">
        <img :src="PicSmall[index]" style="width: 4.2rem; ">

        <div style=" margin-left:5%; width:90% ; text-align:center ">
          <div
            v-bind:class="{ 'Color0' : index==0, 'Color4' : index==4, 'Color5' : index==5, 'Color6' : index==6,
             'Color7' : index==7, 'ColorBrown' : index==1 || index==2 || index==3, 'Color8' : index==8  }"
            style="margin-top: -0.2rem ;  font-size:0.34rem ; font-weight:bold "
          >{{ HotelShort[index] }}</div>
          <div
            style="margin:0.4rem 0 0.1rem 0% ; color:#333333 ; font-size:0.26rem ;  text-align:left ;  "
          >{{ HotelLong[index] }}</div>

          <div style="height:0.3rem"></div>

          <!-- 这里加四个框框 -->
          <div style="  width:92% ; overflow:hidden ; margin:auto">
            <!-- <a :href=" HotelScenery[index]">
              <div class="SiGeKuang0223" >
                <img src="../../../static/home/Brand/Entrance5.png" style="  " />
                全景展示
              </div>
            </a>-->
            <div>
              <div class="SiGeKuang0223" v-on:click="GoOtherPage(HotelDescrib[index],index)">
                <img src="../../../static/home/Brand/Entrance6.png" style="  ">
                <div>品牌展示</div>
              </div>
              <div class="SiGeKuang0223_Split"></div>

              <div class="SiGeKuang0223" v-on:click="GoOtherPage(HotelScenery[index],index)">
                <img src="../../../static/home/Brand/Entrance5.png" style="  ">
                <div>全景展示</div>
              </div>
              <div class="SiGeKuang0223_Split"></div>

              <!-- <a :href=" AllPDFPath[index]"> -->
              <a v-on:click="PostPdfurl(index)">
                <div class="SiGeKuang0223">
                  <img src="../../../static/home/Brand/Entrance7.png">
                  <div>加盟手册</div>
                </div>
              </a>
              <div class="SiGeKuang0223_Split"></div>

              <a v-on:click="PostPdfurl(9)">
                <!-- <a :href=" AllPDFPath[8]"> -->
                <div class="SiGeKuang0223">
                  <img src="../../../static/home/Brand/Entrance8.png">
                  <div>投资手册</div>
                </div>
              </a>
            </div>
          </div>

          <div style="height:0.6rem"></div>

          <div
            v-on:click="GoHotelList( index )"
            class="BGColor3"
            style="  color:white ;font-size:0.36rem ; border-radius: 0.08rem ; line-height:1rem ; z-index:99123"
          >搜索{{ HotelName[index] }}酒店</div>
        </div>

        <div style="  height:0.2rem "></div>
      </swiper-slide>
    </swiper>

    <!-- PDF展示 -->
    <mu-toast
      v-if="toast"
      v-bind:message="TellUser"
      @close="hideToast"
      id="alertline"
      style="margin-bottom:3.1rem"
    />
  </div>
</template>







<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../api";
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import PDFJS from "pdfjs-dist";

// document.getElementsByClassName(".swiper-slide").click(function(e) {
//   alert("点击中了！");
// });

export default {
  data() {
    return {
      IsShow: false,

      swiperOption: {
        pagination: ".swiper-pagination",
        // paginationType : 'fraction',
        paginationClickable: true,
        autoplay: 15000,
        // mousewheelControl: true,
        // 循环会导致最后一个和第一个无效
        // loop: true,
        // loop: true,
        initialSlide: 1
      },

      PicBig: [],
      PicSmall: [],

      HotelShort: [
        "行在云端  功成东方",
        "静享独有格调的中档商务酒店",
        "释放个体价值的中档时尚酒店",
        "追寻无拘无束的中档休闲酒店",
        "经典商务  品质之选",
        "个性选择  共享梦想",
        "城市中的绿洲",
        "懂时尚  更懂年轻",
        "家行千里  如若比邻",
        "一个国家  一段故事"
      ],
      HotelLong: [
        "格林东方酒店是成立于2012年的中高端精品酒店，为商务休闲旅客提供高品质服务。酒店大多数房间定价在300元-600元，一般位于繁华商圈和成熟高新区。酒店客房布局风格多样、个性鲜明，配有商务中心、健康餐饮、美容Spa等服务。",

        "格美酒店成立于2017年，是格林酒店集团旗下中高端商务酒店，大多数房间价格在280元-350元，旨在为商务旅客提供一个独有情调的静享空间。 “Go with Me”，在充满文化气息与优雅设计的格美酒店，体验专属您的商务空间。",
        "格雅酒店成立于2017年，是格林酒店集团旗下中高端时尚酒店，大多数房间价格在280元-350元，旨在为旅客提供一个彰显个性的时尚俱乐部，一同邂逅属于我们的色彩缤纷的精神家园。",
        "格菲酒店成立于2017年，是格林酒店集团旗下中高端休闲酒店，大多数房间价格在280元-350元。酒店融合了青春潮流和艺术内饰，极具本土文化气息，并以多姿多彩的大堂和艺术设计为我们的旅客创造出一个“Very Relaxing”的空间。",

        "格林豪泰酒店是格林酒店集团旗下的中端商务连锁酒店。酒店大多数房间价格在180元-400元，通常位于行政中心、商务中心，为商务休闲旅客提供超值的专业品质服务。格林豪泰酒店配备宽敞明亮的大堂、会议室、商务中心、健身房、24小时免费光纤上网、有线电视及餐饮等配套服务设施。",
        "格盟酒店成立于2008年（*2018由格林联盟升级为格盟），通过理想的地点、卓越的酒店服务、个性化的装饰，向旅客提供别具一格的高品质服务商旅体验，大多数房间价格在150元-400元。酒店通过标准化运营流程、集团自主PMS系统和健康餐饮等，向旅客提供统一的高标准品质服务。",
        "青皮树酒店成立于2013年，绿色天然的环保设计元素，让年轻白领身处都市之中，也能感受自然清新的入住体验。酒店大多数房间价格在150元-300元，倡导舒适、绿色、环保、低碳的生活方式，提供24小时免费光纤上网等配套设施。",
        "贝壳酒店成立于2016年，时尚设计和创意元素相融合，成为青年职业人、背包客、大学生差旅出行的最佳选择。酒店大多数房间定价在99元-260元，贝壳酒店在城市年轻群体中颇受欢迎。",
        //"格林公寓致力于为城市新进者提供中长期公寓租赁及服务，以中端经济型产品先打入市场，继而再带动全国公司宿舍的完善。驻店管家服务、功能区齐全的公共区域、丰富的社群活动、统一标准化管理与完善安全配置，确保住户居住无忧，格林公寓希望用贴心的服务，给您一个想要的生活方式。未来，格林公寓计划在三年内成为酒店类公寓榜首，跻身中国公寓市场前列。",
        "格林公寓致力于为城市新进者提供中长期公寓租赁及服务，以中端休闲娱乐型产品先打入市场，继而再带动全国公司白领住宿的完善。驻店管家服务、功能区齐全的公共区域、丰富的社群活动、统一标准化管理与完善安全配置，确保住户居住无忧，格林公寓希望用贴心的服务，给您一个想要的生活方式。未来，格林公寓计划在三年内成为酒店类公寓榜首，跻身中国公寓市场前列。",
       "国外酒店Overseas Hotel是格林豪泰酒店管理集团重磅推出的国外酒店预订平台，致力于为出境客人提供海量国外酒店信息查询、超值国外酒店预订、实用海外住宿攻略。无论是浪漫的韩国济州岛海景，或是阳光明媚的美国凤凰城，登录格林豪泰“海外酒店”，来一场充满风情的世界之旅。"
      ],

      HotelName: [
        "格林东方",
        "格美",
        "格雅",
        "格菲",
        "格林豪泰",
        "格盟",
        "青皮树",
        "贝壳",
        "格林公寓",
        "国外"
      ],

      brandNumList: ["40", "20", "21", "22", "00", "30", "50", "70","81", "90"],

      // 下面三个都是从后端拿出来的
      // 品牌展示
      HotelDescrib: [
        // "https://q.eqxiu.com/s/Cte0h0Zq",
      ],

      // 全景链接：
      HotelScenery: [
        // "https://www.expoon.com/e/i6n6oz5cx79/panorama?from=singlemessage&isappinstalled=0",
      ],

      AllPDFPath: [
        // "../../../static/home/Brand/加盟手册/8.贝壳加盟手册（A5版）-20180214V1.pdf"
      ],

      // 弹出层 弹出内容
      toast: false,
      TellUser: "",
      // 弹出层 弹出内容  END

      // PDFJS
      totalPage: 0,
      loadedPageCount: 1,

      LoadingPDF: true,

      loadMsg: "上拉加载更多"
    };
  },
  // 数据获取
  computed: {
    ...mapGetters(["g_UserInfo"])
  },
  components: {
    swiper,
    swiperSlide
  },
  //进入时运作
  created() {
    // 获取PDF连接
    this.init();

    // var u = navigator.userAgent;
    // this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    // this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    // alert('是否是Android：'+ this.isAndroid);
    // alert('是否是iOS：'+ this.isIOS);
  },
  methods: {
    // 全景页面 + 品牌展示
    GoOtherPage(URL, index) {
      if (URL == "" || index == 8) {
        this.TellUser = "神秘准备中，先看看其它品牌吧！";
        this.showToast();
        return;
      }

      // 坑爹的安卓APP
      if (this.$route.query.source == "AndroidAPP") {
        this.$router.push({
          path:
            "/home/OtherPage?FromRoute=/home/brandIntroduce?BrandID=" +
            this.brandNumList[index] +
            "&source=AndroidAPP" +
            "&iframePage=" +
            URL
        });
      } else {
        // 不是安卓APP，就常规
        this.$router.push({
          path:
            "/home/OtherPage?FromRoute=/home/brandIntroduce?BrandID=" +
            this.brandNumList[index] +
            "&iframePage=" +
            URL
        });
      }
    },

    init() {
      var pic = "../../../static/";
      // 海外酒店屏蔽，要加上，下面8改成9
      for (var i = 1; i <= 9; i++) {
        this.PicBig.push(pic + "home/Brand/brandpic" + i + ".jpg");

        this.PicSmall.push(pic + "home/Brand/brandlogo" + i + ".png");
      }
      this.GetCompanyPDFPath();
    },

    GetCompanyPDFPath() {
      var params = new this.URLSearchParam();

      this.$http.post(api.GetCompanyPDFPath(), params.toParam()).then(res => {
        if (res.Result) {
          this.AllPDFPath = res.Data.PDFs;
          this.HotelDescrib = res.Data.Describ;
          this.HotelScenery = res.Data.Scenery;
        }
      });
    },

    GoHotelList(index) {
      this.$router.push({
        path: "/search/list?BrandID=" + this.brandNumList[index]
      });
    },

    // 后退一页
    goback() {
      if (this.$router.gxxfrom.path == "/home/OtherPage") {
        this.$router.push({ path: "/home/index" });
      } else {
        this.$router.go(-1);
      }
    },

    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 2000);
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },

    // 下拉继续加载

    // 初始化PDF页面
    PostPdfurl(PDFID) {
      // http://10.3.90.2:10008/home/brandIntroduce?BrandID=40&source=AndroidAPP
      if (this.$route.query.source == "AndroidAPP") {
        // alert("进入方法AndroidAPP")
        android.getPdfurl(this.AllPDFPath[PDFID]);
      } else {
        // alert(" 直接跳转 href： " + this.AllPDFPath[PDFID])
        // console.log(this.AllPDFPath[PDFID])
        // 不是安卓APP，就常规下载
        window.location.href = this.AllPDFPath[PDFID];

        // 这样子浏览器能看，问题是时间不对，APP他们要搞一个URL拦截
        // this.$router.push({
        //   path:
        //     "/home/OtherPage?FromRoute=/home/brandIntroduce?BrandID=" +
        //     40 +
        //     "&iframePage=" +
        //     this.AllPDFPath[PDFID]
        // });
      }
    }
  },
  activated() {
    this.IsShow = true;

    console.log(this.swiperOption);
    var BID = this.$route.query.BrandID;

    if (BID == 40) this.swiperOption.initialSlide = 0;
    else if (BID == "00") this.swiperOption.initialSlide = 4;
    else if (BID == 30) this.swiperOption.initialSlide = 5;
    else if (BID == 50) this.swiperOption.initialSlide = 6;
    else if (BID == 70) this.swiperOption.initialSlide = 7;
    else if (BID == 20)
      // 格美 20// 格雅 21// 格菲 22
      this.swiperOption.initialSlide = 1;
    else if (BID == 21) this.swiperOption.initialSlide = 2;
    else if (BID == 22) this.swiperOption.initialSlide = 3;
    else if (BID == 81) this.swiperOption.initialSlide = 8;
    else if (BID == 90)
      // 国外 没这个页面
      this.swiperOption.initialSlide = 9;
    // else alert(0);

    console.log(this.swiperOption.initialSlide);
  },
  deactivated() {
    this.IsShow = false;
  }
};
</script>






<style lang="less" scoped >
@import "../../assets/theme.less";

.greyline {
  background-color: #f5f5f5;
  height: 1.5vh;
}

.Green {
  color: @primaryColor;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  .title {
    font-size: 130%;
    font-weight: 700;
    color: #333333;
    text-align: left;
    margin: 2vh 0 2vh 2vh;
  }
}

// .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal >
.swiper-pagination-bullets {
  position: absolute;
  top: 3.9rem;
  bottom: 7rem;
}

.linear {
  width: 100%;
  height: 1.3rem;
  opacity: 0.5;
  background: #000000;
  background: -moz-linear-gradient(top, #000000 0%, #ca4534 100%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #000000),
    color-stop(100%, #ffffff)
  );
  background: -webkit-linear-gradient(top, #000000 0%, #ffffff 100%);
  background: -o-linear-gradient(top, #000000 0%, #ffffff 100%);
  background: -ms-linear-gradient(top, #000000 0%, #ffffff 100%);
  background: linear-gradient(to bottom, #000000 0%, #ffffff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(
      startColorstr="#000000",
      endColorstr="#ffffff",
      GradientType=0
    );
}

:root .gradient {
  filter: none;
}

// #eb6100
// #85c028
// #fdd000
// #6eb92b
// #e60012
// 格美格雅格菲都是这个颜色：#82522d
// 国外：#a68258

.Color0 {
  color: #eb6100;
}

.Color4 {
  color: #85c028;
}
.Color5 {
  color: #fdd000;
}
.Color6 {
  color: #6eb92b;
}
.Color7 {
  color: #e60012;
}

// 格美格雅格非
.ColorBrown {
  color: #82522d;
}

// 格林公寓
.Color8 {
  color: #000000;
}

// 海外
.Color9 {
  color: #a68258;
}

.BGColor0 {
  background-color: #eb6100;
}
.BGColor1 {
  background-color: #85c028;
}
.BGColor2 {
  background-color: #fdd000;
}
.BGColor3 {
  background-color: #6eb92b;
}
.BGColor4 {
  background-color: #e60012;
}
.BGColor5 {
  background-color: #82522d;
}
.BGColor8 {
  background-color: #a68258;
}

.SiGeKuang0222 {
  min-height: 3.5rem;

  td {
    color: red;
    background-color: grey;
    min-width: 3rem;
  }
}

.SiGeKuang0223 {
  font-size: 0.24rem;

  color: #666;
  // background-color:grey;
  width: 23%;
  float: left;

  img {
    width: 80%;
  }
}
.SiGeKuang0223_Split {
  width: 2.6%;
  float: left;
  min-height: 1.5rem;
}

.SiGeKuang0223_2 {
  font-size: 0.24rem;

  color: #666;
  // background-color:grey;
  width: 23%;
  float: left;

  img {
    width: 80%;
  }
}
.SiGeKuang0223_Split_2 {
  width: 15%;
  float: left;
  min-height: 1.5rem;
}
</style>


<style lang="less">
#BrandIntroduce {
  .swiper-pagination {
    height: 1rem;
  }
}
</style>







// WEBPACK FOOTER //
// BrandIntroduce.vue?4f5f0681